<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt>
      </a>
      <!-- <a class="menu_btn" href="javascript:;">
        <img src="../assets/img/menu.png" alt>
      </a> -->
    </div>
    <div class="box"></div>
    <div class="success">
      <img src="../assets/img/huiyiSuccess.png" alt>
    </div>
    <div class="successTxt">提交成功</div>
    <div class="description">您已报名参加《{{detail.title}}》，会务组会尽快和您取得联系，沟通相关事宜。</div>
    <div class="friend" v-if="wx">
      <span class="boder"></span>
      <span>邀请朋友一同参会</span>
      <span class="boder"></span>
    </div>
    <div class="icon" v-if="wx">
      <span class="box" @click="fenxiang()">
        <img src="../assets/img/huiyiWechat.png" alt width="45px">
        <span class="text">微信</span>
      </span>
      <span class="box" @click="fenxiang()">
        <img src="../assets/img/huiyiFrends.png" alt width="45px">
        <span class="text">朋友圈</span>
      </span>
      <span class="box" @click="fenxiang()">
        <img src="../assets/img/huiyiLink.png" alt width="45px">
        <span @click="fenxiang()" class="text">复制链接</span>
      </span>
    </div>
    <div v-if="wxfx" class="mark">
      <img src="../assets/img/fenxiangin.png" alt width="100%" height="100%" @click="img">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: "",
      link: "",
      wx: false,
      wxfx: false
    };
  },
  created() {
    this.download();
  },
  mounted() {
    this.content();
  },
  methods: {
    img() {
      this.wxfx = false;
    },
    fenxiang() {
      this.wxfx = !this.wxfx;
    },
    download() {
      let ua = navigator.userAgent.toLowerCase();
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1; //android终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isWeixinBrowser()) {
        this.wx = !this.wx;
      } else {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //ios
          this.wx = !this.wx;
        } else if (/(Android)/i.test(navigator.userAgent)) {
          //android
          this.wx = !this.wx;
        }
      }
      function isWeixinBrowser() {
        return /micromessenger/.test(ua) ? true : false;
      }
    },
    content() {
      this.detail = JSON.parse(localStorage.getItem("detail"));
      if (this.detail.contentId.toString() !== this.$route.query.contentId) {
        //  window.location.href = `/singup?contentId=${this.$route.query.contentId}&categoryId=${this.$route.query.categoryId}&parentId=${this.$route.query.parentId}`;
        window.location.href = window.location.href.replace("share", "singup");
      } else {
        this.$axios
          .post(
            `api/web/phone/content/detail/${this.$route.query.contentId}`,
            {}
          )
          .then(res => {
            console.log("res", res);
            this.detail = res.data;
          });
        const fenxiangdizhi = window.location.href.replace("share", "singup");
        console.log("tag", fenxiangdizhi);
        this.wxShare(
          this.detail.title,
          this.detail.description,
          this.detail.thumbApp,
          fenxiangdizhi
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.mark {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.box {
  display: inline-block;
  margin: 0 35px;
}
.text {
  display: block;
  font-size: 12px;
  color: #a7a7a7;
}
.friend {
  span {
    display: inline-block;
    font-size: 12px;
    color: #797979;
    margin-bottom: 17px;
  }
}
.description {
  padding: 11px 51px 80px;
  font-size: 12px;
  color: #797979;
}
.successTxt {
  font-size: 16px;
  font-weight: 700;
  color: #232323;
}
.success {
  padding: 120px 128px 19px;
  img {
    width: 100%;
    height: auto;
  }
}
.box {
  height: 56px;
}
.body {
  //   background: #fff;
  //   min-height: 100vh;
  //   box-sizing: border-box;
  // //   position: relative;
  // //   overflow: auto;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;
  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;
    img {
      height: 35px;
    }
  }
  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;
    img{
      height:40px;
    }
  }
}
</style>
<style scoped>
.body >>> .boder {
  display: inline-block;
  width: 76px;
  border: 0.5px solid #d3e1d8;
  margin-bottom: 4px;
  margin-left: 11.8px;
  margin-right: 11.8px;
}
</style>




// WEBPACK FOOTER //
// src/components/share.vue